import * as React from 'react';

import FadeIn from '@/components/FadeIn/FadeIn';

type IHeroProps = object;

const Hero: React.FunctionComponent<IHeroProps> = () => {
  return (
    <section className='relative pt-20 pb-16 md:pt-30 md:pb-28 rounded-2xl mx-4 md:mx-[30px] bg-[url(/images/about/about-hero-bg.png)] bg-no-repeat bg-bottom bg-cover mt-11'>
      <div className='container mx-auto px-4 md:px-8 xl:px-25 flex flex-col items-center text-center'>
        <FadeIn variant='down' delay={0.2}>
          <h1 className='text-4xl md:text-5xl lg:text-6xl font-medium text-blue-500 mb-6'>
            Welcome to marketbetter
          </h1>
        </FadeIn>
        <FadeIn variant='up' delay={0.3}>
          <p className='text-2xl md:text-[24px] text-black/70 max-w-5xl mb-6'>
            We replace your mar-tech stack with AI agents that run prospecting, email, ads, and
            reporting—hands-off.
          </p>
        </FadeIn>
      </div>
    </section>
  );
};

export default Hero;
